import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { UpdateUserFullNameInput } from '../../schemas/user';
import { updateUserFullNameSchema } from '../../schemas/user';
import { Form, FormInput } from '../ui';
import { Modal, ModalFooter } from '../ui/modal';

interface RenameUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  userEmail: string;
  currentFullName: string;
  onSubmit: (data: UpdateUserFullNameInput) => Promise<void>;
}

export function RenameUserModal({
  isOpen,
  onClose,
  userEmail,
  currentFullName,
  onSubmit,
}: RenameUserModalProps) {
  const form = useForm<UpdateUserFullNameInput>({
    resolver: zodResolver(updateUserFullNameSchema),
    defaultValues: { full_name: currentFullName },
  });

  useEffect(() => {
    if (isOpen) {
      form.reset({ full_name: currentFullName });
    }
  }, [isOpen, currentFullName, form]);

  const handleClose = () => {
    form.reset();
    onClose();
  };

  const handleFormSubmit = async (data: UpdateUserFullNameInput) => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Modifier le nom"
      size="md"
      footer={
        <ModalFooter
          onCancel={handleClose}
          submitLabel="Enregistrer"
          isSubmitting={form.formState.isSubmitting}
          formId="rename-user-form"
        />
      }
    >
      <Form {...form}>
        <form id="rename-user-form" onSubmit={form.handleSubmit(handleFormSubmit)}>
          <div className="flex flex-col gap-4">
            <div className="text-sm text-zinc-600">
              Utilisateur : <span className="font-semibold text-zinc-900">{userEmail}</span>
            </div>

            <FormInput
              control={form.control}
              name="full_name"
              label="Nom complet"
              required
              placeholder="Prénom Nom"
            />
          </div>
        </form>
      </Form>
    </Modal>
  );
}
